import { Components, Theme } from '@mui/material/styles'

export const buttonTheme: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
    containedSizeLarge: {
      fontSize: '1.4rem',
    },
    iconSizeLarge: {
      '&> *:first-of-type': {
        fontSize: '1.6rem',
      },
    },
  },
  defaultProps: {
    disableElevation: true,
    size: 'large',
    variant: 'contained',
  },
}
